// src/context/PermissionContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import BaseURL from "../api/AppURL";

const PermissionContext = createContext([]);

export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (!token) return;

    axios.get(`${BaseURL}/me/permissions`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(res => {
      setPermissions(res.data.permissions || []);
    })
    .catch(() => setPermissions([]));
  }, []);

  return (
    <PermissionContext.Provider value={permissions}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionContext);
